import { LcaResultModel } from 'types/types';
import { MODULE_FIELDS } from './gridMapping';

export type ValidationError = {
  indicatorId: string;
  field: string;
  message: string;
};

/**
 * Validate a cell value for a given module field.
 * Returns an error message if invalid, or null if valid.
 */
export function validateCellValue(value: string, _field: keyof LcaResultModel): string | null {
  // Empty and 'ND' (No Data) are always valid
  if (value === '' || value.toUpperCase() === 'ND') {
    return null;
  }

  // Must be a valid number
  const parsed = parseFloat(value);
  if (isNaN(parsed)) {
    return 'Value must be a number or "ND"';
  }

  return null;
}

/**
 * Validate all changed rows before sending to backend.
 * Returns array of validation errors (empty if all valid).
 */
export function validateChangedRows(rows: LcaResultModel[]): ValidationError[] {
  const errors: ValidationError[] = [];

  for (const row of rows) {
    for (const field of MODULE_FIELDS) {
      const value = row[field]?.toString() || '';
      if (value === '' || value.toUpperCase() === 'ND') continue;

      const error = validateCellValue(value, field);
      if (error) {
        errors.push({
          indicatorId: row.indicatorId || '',
          field: field as string,
          message: error,
        });
      }
    }
  }

  return errors;
}
